export const DefaultSections =
{
    Start: 'introduction',
    End: 'thank-you',
    SlideSorter: 'slide-sorter'
};
